import React from 'react'
import PropTypes from 'prop-types'
import _ from 'underscore'
import { connect } from 'react-redux'
import { Row, Col } from 'react-bootstrap'
import { touch } from 'redux-form'

import {
  selectNewDate,
  selectScheduleRange,
  storeAppointmentDataValues,
  cleanAppointmentStore,
  loadAppointmentData,
  persistDatePickerUIValues,
  fetchEmptyDates
} from './actions'
import AppointmentCalendar from './appointmentCalendar.component'
import { configuration } from '../../../configuration'

import './styles.css'
import moment from 'moment'

class Appointment extends React.Component {

  static propTypes = {
    appointmentStore: PropTypes.shape({
      date: PropTypes.date,
    }),
    selectNewDate: PropTypes.func.isRequired,
    selectScheduleRange: PropTypes.func.isRequired,
    switchCheckoutContent: PropTypes.func.isRequired,
    validAppointmentData: PropTypes.func.isRequired,
    cleanStore: PropTypes.func.isRequired,
    storeAppointmentDataValues: PropTypes.func.isRequired,
    checkoutStore: PropTypes.object
  }

  state = {
    scheduleRangeError: false,
  }

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleScheduleRange = this.handleScheduleRange.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.persistDatePickerUIValues = this.persistDatePickerUIValues.bind(this);
  }

  handleChange(newDate) {
    this.props.selectNewDate(newDate);
  }

  handleScheduleRange(newRange) {
    this.props.selectScheduleRange(newRange);
  }

  persistDatePickerUIValues() {
    this.props.persistDatePickerUIValues();
  }

  wouldSooner() {
    alert('would sooner');
  }


  handleNext() {
    //TODO: DEUDA TECNICA: HAY QUE MOSTRAR LOS ERRORES DE FORMULARIO

    let pickupService = false;
    let pickupServiceValidData = false;
    // Comprobacion de que se ha rellenado la direccion de Recogida y Entrega
    if (this.props.shoppingCart !== false) {
      _.map(this.props.shoppingCart.items, (item) => {
        if (item.name === configuration().servicioRecogidaYEntrega) {
          // servicio de recogida y entrega seleccionado
          pickupService = true;
        }
      })
      if (pickupService && this.props.appointmentStore.pickupAddress !== null) {
        pickupServiceValidData = true;
      }
    }

    if (this.props.appointmentStore.selectedDate !== false && this.props.appointmentStore.selectedTime !== false) {
      if (pickupService && pickupServiceValidData || pickupService === false) {
        this.props.persistDatePickerUIValues();
        this.props.switchCheckoutContent('personalData')
      }
    }
  }

  componentWillMount() {
    // Load previously saved data to the appointment
    const appointmentData = this.props.appointmentStore.appointmentData;
    if (appointmentData && appointmentData.scheduleRange) {
      this.props.selectScheduleRange(appointmentData.scheduleRange);
    }
    if (appointmentData && appointmentData.date) {
      this.props.selectNewDate(appointmentData.date);
    }

    // Vamos pidiendo los dias sin slots
    this.props.fetchEmptyDates(moment(), configuration().workshopEmailHash)
  }

  componentWillUnmount() {
    this.props.cleanStore([
      'canRedirect',
      'error'
    ])
  }

  render() {
    var calendar = this.props.appointmentStore.emptyDates
      ? <AppointmentCalendar errors={{ ...this.state }} />
      : <div><span>Por favor espere.<br /></span><div><i className="fa fa-spinner fa-pulse fa-3x fa-fw Demo__spinner" /></div></div>
    return (
      <React.Fragment>
        {calendar}
        <br />
        <Row>
          <Col md={3} sm={6}>
            <button className=" responsivebutton jump pull-left button-secondary router-buttons" onClick={() => this.props.switchCheckoutContent('services')}>{configuration().arrowInButon ? <i className="fa fa-angle-left" aria-hidden="true"></i> : ''}
              <span className="labelFlip1">ATRÁS</span>
              <span className="labelFlip2" style={{ visibility: 'hidden' }}>ATRÁS</span>
            </button>
          </Col>
          {this.props.appointmentStore.emptyDates ?
            <Col md={3} sm={6} className="offset-md-6">
              <button
                className="responsivebutton jump pull-right blue-button-active"
                style={{
                  backgroundColor: configuration().clientColor,
                  borderColor: configuration().clientColor
                }}
                onClick={this.handleNext}>
                <span className="labelFlip1">SIGUIENTE</span>
                <span className="labelFlip2" style={{ visibility: 'hidden' }}>SIGUIENTE</span>{configuration().arrowInButon ? <i className="fa fa-angle-right" aria-hidden="true"></i> : ''}
              </button>
            </Col> : null}
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  appointmentStore: state.checkout.appointment,
  shoppingCart: state.checkout.shoppingCart,
  checkoutStore: state.checkout.checkoutRoot,
  addressForm: state.form.addressForm || {},
  appointmentDataForm: state.form.appointmentDataForm || {},
})

const bindActions = dispatch => ({
  selectNewDate: newDate => dispatch(selectNewDate(newDate)),
  selectScheduleRange: newRange => dispatch(selectScheduleRange(newRange)),
  storeAppointmentDataValues: values => dispatch(storeAppointmentDataValues(values)),
  cleanStore: props => dispatch(cleanAppointmentStore(props)),
  loadAppointmentData: data => dispatch(loadAppointmentData(data)),
  touchFormField: (form, field) => dispatch(touch(form, field)),
  persistDatePickerUIValues: () => dispatch(persistDatePickerUIValues()),
  fetchEmptyDates: (date, autocare) => dispatch(fetchEmptyDates(date, autocare))
})

export default connect(mapStateToProps, bindActions)(Appointment)


// WEBPACK FOOTER //
// ./src/workflow/checkout/appointment/index.js